import { render } from "./Plans.vue?vue&type=template&id=177e5f7f&scoped=true"
import script from "./Plans.vue?vue&type=script&lang=js"
export * from "./Plans.vue?vue&type=script&lang=js"

import "./Plans.vue?vue&type=style&index=0&id=177e5f7f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-177e5f7f"

export default script